import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user submits an MFA phone-verification code
 * Event: dental_portal:mfa:code_submitted
 */
export function fireMfaCodeSubmitted(): void {
  PosthogService.getInstance().track('dental_portal:mfa:code_submitted');
}
